<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id && !mostrarseComoNaturaleza" :value="tipo.Id">{{tipo.Nombre}} un juicio</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id && mostrarseComoNaturaleza" :value="tipo.Id">{{tipo.Nombre}} una naturaleza</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los juicios</option>
        <option v-for="Juicio in Juicios" :value="Juicio.JuicioId" :key="Juicio.JuicioId">{{Juicio.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default
  {
    data() {//Data
      return {
        enumeraciones,
        comun,
        Juicios:[],
        idDelModelo: null
      }
    },
    props: { //Props
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      materia: '',
      parametros: Object,
      mostrarseComoNaturaleza: false
    },
    mounted() {
       if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer042Juicio", { llave: this.idDelInput, valor: this.idDelModelo });
    },
    methods: {
    RegresaIdMateria(){
      if(this.materia == 'Contencioso')
        return 1;
      if(this.materia == 'Civil')
        return 2;
      if(this.materia == 'Mercantil')
        return 3;
      if(this.materia == 'Familiar')
        return 4;
      if(this.materia == 'Laboral')
        return 13;
    },
    cargarCatalogoDeJuicios(){
      if(this.parametros == null || this.parametros == undefined)
        this.parametros = {};
      if(!this.parametros.MateriaId && this.materia)
        this.parametros.MateriaId = this.RegresaIdMateria();

      this.parametros.EsPrueba = this.enumeraciones.EsPrueba;

      axios
      .post(api.conexion + api.PJ.catalogos.C042Juicios, this.parametros)
      .then(respuesta => 
      {
        if (respuesta.data.SiHayError) {
          comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
        } else {
          this.Juicios = respuesta.data.Juicios;
          //return respuesta.data.Juicios;
        }
      })
      .catch(e => 
      {
        console.log(e);
        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
      });
    },//cargarCatalogoDeJuicios
    cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const params = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogo_Establecer042Juicio", params);
        this.$emit("valorParaElPadre", evento);
      }
    },//Methods
    created() {
      this.cargarCatalogoDeJuicios();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/042Juicios.vue